import React from 'react';
import { makeStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid #E0E0E0',
    fontSize: 14,
    borderRadius: '2px',
    maxWidth: '400px',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.08)',
    fontWeight: 'normal',
    margin: '1px 7px'
  },
  arrow: {
    '&::before': {
      border: '1px solid #E0E0E0',
      borderRadius: '2px'
    },
    color: 'white',
    top: 'inherit !important'
  }
});

export const PendingIndicatorIcon = ({ style, title = 'unknown' }) => {
  const classes = useStyles();
  return (
    <Tooltip
      disableTouchListener
      disableFocusListener
      placement="right-start"
      arrow
      title={title}
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow
      }}
    >
      <div
        style={
          style || {
            display: 'flex',
            margin: '7px 8px 0px 0px',
            alignSelf: 'flex-start'
          }
        }
      >
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
        >
          <circle cx="4" cy="4" r="4" fill="#EF6C00" />
        </svg>
      </div>
    </Tooltip>
  );
};
